<!-- 发货计划 - deliveryPlan -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <!-- 装车单 -->
            <deliveryPlanAction v-if="showStatus&&actionDataShow" ref="deliveryPlanAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></deliveryPlanAction>
            <!-- 发物流 -->
            <deliveryPlanAction1 v-if="showStatus&&!actionDataShow" ref="deliveryPlanAction1" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></deliveryPlanAction1>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :flagList="['orderType']" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-select clearable size="mini" v-if="formOneValue.entityField == 'orderType'" v-model="getRequestData[formOneValue.entityField]" placeholder="请选择">
                            <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                        </el-select>
                    </template>
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border show-summary :summary-method="getSummaries" @select="selectData"
                      @selection-change="selectChange" style="width: 100%" highlight-current-row size="mini">
                <el-table-column align="center" type="selection" :selectable="checkboxT" width="40"> </el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                    <el-table-column align="center" :sortable="tableValye.isSort==1?true:false" v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" show-overflow-tooltip
                                     :min-width="tableValye.fieldWeight" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField] != null">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                            <el-tag size="mini" v-else-if="tableValye.fieldType == 'formatter'">{{
      $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                            <div v-else-if="tableValye.entityField == 'sfllpath' && scope.row[tableValye.entityField]">
                                <el-image v-for="(img, imgIndex) in getSfllImgs(scope.row[tableValye.entityField])" :key="imgIndex"
                                          style="width: 40px; height: 40px; margin: 2px" :src="img" fit="cover"
                                          :preview-src-list="getSfllImgs(scope.row[tableValye.entityField])">
                                </el-image>
                            </div>
                            <span v-else-if="tableValye.isRift == 1">
                                <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                }}</a>
                            </span>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-drawer :close-on-press-escape="true" :visible.sync="editVisible" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="1" :activeName="'修改配送方式'" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div v-if="scope.index == 0">
                                <el-form id="mainInfo" :model="editOrder" class="baseForm" label-width="120px">
                                    <el-row>
                                        <el-form-item label="配送方式">
                                            <el-tooltip class="item" :disabled="editOrder.deliveryMethod == null || editOrder.deliveryMethod == '' ? true : false || editOrder.deliveryMethod.length <= 9" effect="dark"
                                                        :content="editOrder.deliveryMethod" placement="bottom-start">
                                                <el-input clearable v-model="editOrder.deliveryMethod"
                                                          @keyup.enter.native="openSearch({ sId: '566060974575616', index: 0, type: 'deliveryMethod', sField: 'deliveryMethod' })">
                                                    <el-button @click="openSearch({ sId: '566060974575616', index: 0, type: 'deliveryMethod', sField: 'deliveryMethod' })" slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                            </el-tooltip>
                                        </el-form-item>
                                        <el-tooltip v-if="editOrder.deliveryMethod == '物流'" class="item"
                                                    :disabled="editOrder.companyName == null || editOrder.companyName == '' ? true : false || editOrder.companyName.length <= 9" effect="dark"
                                                    :content="editOrder.companyName" placement="bottom-start">
                                            <el-form-item label="物流公司" prop="companyName">
                                                <el-input clearable v-model="editOrder.companyName" @keyup.enter.native="openSearch({ sId: '578295613558784', index: 0, type: 'companyName1', sField: 'companyName' })">
                                                    <el-button @click="openSearch({ sId: '578295613558784', index: 0, type: 'companyName1', sField: 'companyName' })" slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                            </el-form-item>
                                        </el-tooltip>
                                        <el-form-item label="收货员">
                                            <el-tooltip class="item" :disabled="editOrder.recName == null || editOrder.recName == '' ? true : false || editOrder.recName.length <= 9" effect="dark"
                                                        :content="editOrder.recName" placement="bottom-start">
                                                <el-input clearable v-model="editOrder.recName" @keyup.enter.native="openSearch({ sId: '8820873997127123', index: 0, type: 'recName', sField: 'recName, recId' })">
                                                    <el-button @click="openSearch({ sId: '8820873997127123', index: 0, type: 'recName', sField: 'recName, recId' })" slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                            </el-tooltip>
                                        </el-form-item>
                                        <el-form-item label="收货地址">
                                            <el-tooltip class="item" :disabled="editOrder.caiAddress == null || editOrder.caiAddress == '' ? true : false || editOrder.caiAddress.length <= 9" effect="dark"
                                                        :content="editOrder.caiAddress" placement="bottom-start">
                                                <el-input clearable v-model="editOrder.caiAddress" @keyup.enter.native="openSearch({ sId: '423073365168128', index: 0, type: 'caiAddress', sField: 'caiAddress, caiId' })">
                                                    <el-button @click="openSearch({ sId: '423073365168128', index: 0, type: 'caiAddress', sField: 'caiAddress, caiId' })" slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                            </el-tooltip>
                                        </el-form-item>
                                        <el-form-item label="包裹数量">
                                            <el-input clearable v-model="editOrder.lonum" type="number">
                                                <!-- <el-button @click="openSearch('423073365168128', 'caiAddress', 'caiAddress, caiId')" slot="append" icon="el-icon-search"></el-button> -->
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="保价">
                                            <el-input clearable v-model="editOrder.insure" type="number"></el-input>
                                        </el-form-item>
                                        <el-form-item label="重量">
                                            <el-input clearable v-model="editOrder.sumWeight" type="number"></el-input>
                                        </el-form-item>
                                        <el-form-item label="体积">
                                            <el-input clearable v-model="editOrder.volume" type="number"></el-input>
                                        </el-form-item>
                                        <el-form-item v-show="editOrder.caiAddress.length" label="省">
                                            <el-input clearable readonly v-model="editOrder.caiProvince"></el-input>
                                        </el-form-item>
                                        <el-form-item v-show="editOrder.caiAddress.length" label="市">
                                            <el-input clearable readonly v-model="editOrder.caiCity"></el-input>
                                        </el-form-item>
                                        <el-form-item v-show="editOrder.caiAddress.length" label="区">
                                            <el-input clearable readonly v-model="editOrder.caiArea"></el-input>
                                        </el-form-item>
                                        <el-form-item v-show="editOrder.caiAddress.length" label="收货人">
                                            <el-input clearable readonly v-model="editOrder.caiLinker"></el-input>
                                        </el-form-item>
                                        <el-form-item v-show="editOrder.caiAddress.length" label="收货人电话">
                                            <el-input clearable readonly v-model="editOrder.caiTelnumber"></el-input>
                                        </el-form-item>
                                    </el-row>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foots">
                    <el-button type="primary" @click="subEdit">确认修改</el-button>
                </div>
            </div>
        </el-drawer>
        <el-drawer :close-on-press-escape="true" :visible.sync="wlVisible" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="1" :activeName="'维护物流信息'" :name="'jciName'" :value="'jciName'" :tabslist="tabForm1" @tabs="(val) => { showTabs = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div v-if="scope.index == 0">
                                <el-form :model="wlInfo" class="baseForm" inline label-width="150px">
                                    <el-row>
                                        <el-form-item label="物流公司" prop="companyName">
                                            <el-tooltip class="item" :disabled="wlInfo.companyName == null || wlInfo.companyName == '' ? true : false || wlInfo.companyName.length <= 9" effect="dark"
                                                        :content="wlInfo.companyName" placement="bottom-start">
                                                <el-input clearable v-model="wlInfo.companyName" @keyup.enter.native="openSearch({ sId: '578295613558784', index: 0, type: 'companyName2', sField: 'companyName2' })">
                                                    <el-button @click="openSearch({ sId: '578295613558784', index: 0, type: 'companyName2', sField: 'companyName2' })" slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                            </el-tooltip>
                                        </el-form-item>
                                        <el-form-item label="物流单号" prop="logisticsNum">
                                            <el-input v-model="wlInfo.logisticsNum" clearable></el-input>
                                        </el-form-item>
                                        <el-form-item label="物流费用" prop="logisticsMoney">
                                            <el-input v-model="wlInfo.logisticsMoney" clearable></el-input>
                                        </el-form-item>
                                    </el-row>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foots">
                    <el-button type="primary" @click="subWlInfo">确认修改</el-button>
                </div>
            </div>
        </el-drawer>
        <el-drawer :close-on-press-escape="true" :visible.sync="ztVisible" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="50%">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED">
                    <v-tabs :type="1" :activeName="'维护自提信息'" :name="'jciName'" :value="'jciName'" :tabslist="[{ jciName: '维护自提信息' }]" @tabs="(val) => { showTabs = val }">
                        <template slot="tabs">
                            <div>
                                <el-form :model="ztInfo" ref="ztInfo" class="baseForm" inline label-width="150px">
                                    <el-row>
                                        <el-col :span="24">
                                            <el-form-item label="自提人" prop="carryName" :required="true">
                                                <el-input v-model="ztInfo.carryName" size="mini" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="自提车牌号" prop="carryNumberPlate">
                                                <el-input v-model="ztInfo.carryNumberPlate" size="mini" clearable></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="自提时间" prop="carryTime">
                                                <el-date-picker class="form_codition" size="mini" v-model="ztInfo.carryTime" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
                                                </el-date-picker>
                                            </el-form-item>
                                        </el-col>

                                    </el-row>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foots">
                    <el-button type="primary" @click="subztInfo">提交</el-button>
                </div>
            </div>
        </el-drawer>
        <el-dialog title="上传图片" :visible.sync="sfllVisible" width="50%" append-to-body :close-on-click-modal="false">
            <upDataImg :isGPY="false" :printScanShow="false" :liangtianShow="false" :initFiles="sfllInitFiles" v-if="sfllVisible" ref="upDataImg" :limit="3"></upDataImg>
            <div slot="footer" class="dialog-footer">
                <el-button @click="sfllVisible = false">取 消</el-button>
                <el-button type="primary" @click="subSfllpath">提 交</el-button>
            </div>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <customDesign ref="customDesign"></customDesign>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../byComponents/SearchScheme.vue"
import { updateKdnStatusUrl } from "@/service/api.js";
import deliveryPlanAction from "@/components/deliveryPlanAction.vue";
import deliveryPlanAction1 from "@/components/deliveryPlanAction1.vue";
import upDataImg from "@/byComponents/upDataImg.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        deliveryPlanAction,
        deliveryPlanAction1,
        upDataImg
    },
    data() {
        //这里存放数据
        return {
            ztVisible: false,
            ztInfo: {},
            sfllVisible: false, //上传图片弹窗
            sfllInitFiles: [], //上传图片回显
            imgUrl: window.global_config.BASE_IMG_URL,
            tableHeight: 0,
            wlInfo: {
                companyName: '',
                logisticsNum: '',
                logisticsMoney: '',
                ids: []
            },
            getRequestData: {
                businessId: "", //	业务id	
                deliveryMethod: "", //	配送方式
                loId: "", //	物流公司
                companyName: "",
                orderType: "", //	订单类型0.普通订单1.冷链
                ormId: "", //
                page: 1, //	当前页
                rows: 200, //	每页条数
                spState: "", //	状态0.生成销售单1.生成记账单2.生成装车单
                start:
                    new Date(new Date().toLocaleDateString()).getTime() -
                    31 * 24 * 3600 * 1000, //开始上一个月
                end:
                    new Date(new Date().toLocaleDateString()).getTime() +
                    24 * 60 * 60 * 1000 -
                    1, //当天最后时间
                spState: '', //订单状态
                coName: '',
                coId: ''
            },
            tabForm1: [{
                jciName: "维护物流信息",
                jurconfigform: [],
            }],
            wlVisible: false,
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },
            tabForm: [
                {
                    jciName: "修改配送方式",
                    jurconfigform: [],
                }
            ],
            editVisible: false,
            editOrder: { //修改信息
                companyName: "",
                deliveryMethod: "",
                loId: "",
                lonum: '',
                spId: "",   //	id
                recName: "",    //
                recId: "",
                caiAddress: "",
                caiId: "",
                caiLinker: '',
                caiTelnumber: '',
                caiProvince: '',
                caiCity: '',
                caiArea: '',
                insure: '',
                sumWeight: '',
                volume: '',
            },
            selectRow: {},
            buttonList: [],
            pageShowData: [],
            selectedDataIndex: 0,
            selectList: [],  //选择单据列表
            parentSearchData: {},
            seId: "",
            seTitle: "",
            seWidth: "",
            DialogVisible: false,
            seType: '',
            isShowTooltip: false,
            showStatus: false,
            actionData: {},
            actionDataShow: false,
            sField: '',
            requesUrl: '',
            imgUrl: '',
            ormId: '',
            formDataList: []
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        'getRequestData.companyName': {
            handler(newVal) {
                if (newVal == '') this.getRequestData.loId = ''
            },
            deep: true
        },
        'getRequestData.coName': {
            handler(newVal) {
                if (newVal == '') this.getRequestData.coId = ''
            },
            deep: true
        },
        'wlInfo.companyName': {
            handler(newVal) {
                if (newVal == '') this.wlInfo.loId = ''
            },
            deep: true
        },
        'editOrder.companyName': {
            handler(newVal) {
                if (newVal == '') this.editOrder.loId = ''
            },
            deep: true
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.ormId = sessionStorage.getItem('ormId')
        this.getPageInfo()

        this.imgurl()
    },
    //方法集合
    methods: {
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                } else if (column.property == 'logisticsMoney') {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                    } else {
                        sums[index] = '';
                    }
                } else {
                    sums[index] = '';
                    return;
                }
            });
            return sums;
        },
        //获取图片存取的根路径
        imgurl() {
            // console.log(this.$store.getters.getConfig);
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        //  导出
        exportData() {
            window.location.href = this.requesUrl + '/shipPlan/exportShipPlan?ormId=' + String(this.ormId) + '&companyName=' + this.getRequestData.companyName
                + '&&loId=' + this.getRequestData.loId + '&&start=' + this.getRequestData.start + '&&end=' + this.getRequestData.end
                + '&&orderType=' + this.getRequestData.orderType + '&&spState=' + this.getRequestData.spState
                + '&&page=' + this.getRequestData.page + '&&rows=' + this.getRequestData.rows
        },
        //复选框
        checkboxT(row, rowIndex) {
            if (this.returnData.list[rowIndex].spState == 2) {
                return false; //禁用
            } else {
                return true; //不禁用
            }
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({
                    //向窗口发送MessageEvent消息
                    cmd: "returnFormJson",
                    params: {
                        isPenetrate
                    }, //参数
                },
                    "*"
                );
            }
        },
        //  维护物流信息
        async subWlInfo() {
            let ids = []
            this.selectList.forEach(item => {
                ids.push(item.spId)
            })
            this.wlInfo.ids = ids
            let responseData = await this.$http.updateLogisticsWl(this.wlInfo)
            if (responseData.status == 200) {
                this.$message({
                    type: 'success',
                    message: responseData.message,
                });
                this.wlVisible = false
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        //获取订单状态  状态0.销售出库1.销售记账2.生成装车单
        getSpState(status) {
            let str = ""
            if (status != "" || status != null) {
                if (status == 0) {
                    str = '生成订单'
                } else if (status == 1) {
                    str = '生成记账单'
                } else if (status == 2) {
                    str = '生成装车单'
                } else {
                    str = status
                }
                return str
            } else {
                return status
            }
        },
        //选择框变化
        selectData(val, row) {
            // console.log('all--',val, row);
            // if(row.spState == 2){
            //     this.$message({
            //         message: '已生成装车单不能再次生成！',
            //         type: 'error'
            //     });
            //     this.$refs.multipleTable.toggleRowSelection(row);
            // }else{
            //     this.selectRow = row
            // }
        },
        //选择框变化
        selectChange(val) {
            this.selectList = val
        },
        //获取最后时间点
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 子组件触发
        drawerCancel() {
            this.showStatus = false
            this.getDataList()
            this.returnData.list.splice(1, 0)
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
        },

        // 检索Id, 索引(表格中), 标识
        openSearch({ sId, type, sField }) {
            this.seId = sId
            this.seType = type
            this.sField = sField
            if (type == 'companyName2') {
                this.parentSearchData.companyName = this.wlInfo.companyName
            } else if (type == 'deliveryMethod') {
                this.parentSearchData.deliveryMethod = this.editOrder.deliveryMethod
            } else if (type == 'recName') {
                this.parentSearchData.salesName = this.editOrder.recName
                this.parentSearchData.unitId = this.selectList[0].cmId
            } else if (type == 'caiAddress') {
                this.parentSearchData.caiAddress = this.editOrder.caiAddress
                this.parentSearchData.cmId = this.selectList[0].cmId
            } else {
                this.parentSearchData[type] = this.getRequestData[type]
            }
            this.DialogVisible = true
        },
        //返回数据
        changeInputModel(val) {
            console.log(val, this.seType);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (this.seType == 'companyName2') {
                    this.wlInfo.companyName = val.companyName
                    this.wlInfo.loId = val.loId
                    return
                } else if (this.seType == 'deliveryMethod') {
                    this.editOrder.deliveryMethod = val.dismode
                    return
                } else if (this.seType == 'recName') {
                    this.editOrder.recId = val.recId
                    this.editOrder.recName = val.recName
                    return
                } else if (this.seType == 'companyName1') {
                    this.editOrder.loId = val.loId
                    this.editOrder.companyName = val.companyName
                    return
                } else if (this.seType == 'caiAddress') {
                    this.editOrder.caiId = val.caiId
                    this.editOrder.caiAddress = val.caiAddress
                    this.editOrder.caiLinker = val.caiLinker
                    this.editOrder.caiTelnumber = val.caiTelnumber
                    this.editOrder.caiProvince = val.caiProvince
                    this.editOrder.caiCity = val.caiCity
                    this.editOrder.caiArea = val.caiArea
                    return
                }
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            console.log(this.sField);
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },

        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType)
            switch (actionData.actionType) {    //shipPlanAddLoading
                case 0:
                    if (this.selectList.length < 1) {
                        this.$message({
                            message: '至少选中一条数据进行生成！',
                            type: 'warning'
                        });
                        return false
                    }

                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList.filter(item => item.jciId == 11712),
                        oldData: this.selectList,
                        orderId: '',
                        printSouce: '',
                        printJurId: ''
                    }
                    for (let i = 0; i < this.actionData.oldData.length; i++) {
                        if (this.actionData.oldData[i].wobkemId == null || this.actionData.oldData[i].wobkemId == ''
                            || this.actionData.oldData[i].wobkemId == undefined) {
                            return this.$message({
                                message: '需记账后方可生成装车单！',
                                type: 'error'
                            });
                        }
                    }
                    this.actionDataShow = true //装车单
                    this.showStatus = true
                    break;
                case 1:
                    if (this.selectList.length > 1 || this.selectList.length < 1) {
                        this.$message({
                            message: '请选中一条数据进行编辑！',
                            type: 'error'
                        });
                        return false
                    }
                    var dataInfo = this.selectList[0]
                    for (const key in this.editOrder) {
                        if (key == 'recName' || key == 'caiAddress') {
                            this.editOrder[key] = ""
                        } else {
                            this.editOrder[key] = dataInfo[key];
                        }
                    }
                    this.editVisible = true
                    break;
                // case 2:
                //     this.delDataAction()
                //     break;
                case 3:
                    this.openWl()
                    break;
                case 4:
                    this.exportData()
                    break;
                case 5:
                    this.KdnStatusUrls()

                    break;
                case 6:

                    this.closePlan()

                    break;
                case 7:
                    this.showPrintPlan()

                    break;
                case 8:
                    if (this.selectList.length < 1) {
                        this.$message({
                            message: '至少选中一条数据！',
                            type: 'warning'
                        });
                        return false
                    }
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList.filter(item => item.jciId == 11796),
                        oldData: this.selectList,
                        orderId: '',
                        printSouce: '',
                        printJurId: ''
                    }
                    for (let i = 0; i < this.actionData.oldData.length; i++) {
                        if (this.actionData.oldData[i].wobkemId == null || this.actionData.oldData[i].wobkemId == ''
                            || this.actionData.oldData[i].wobkemId == undefined) {
                            return this.$message({
                                message: '需记账后方可发物流！',
                                type: 'error'
                            });
                        }
                    }
                    this.actionDataShow = false//发物流
                    this.showStatus = true
                    break;
                case 9:
                    this.showPrintPlan(9)

                    break;
                case 10: //上传图片
                    if (this.selectList.length != 1) {
                        this.$message({
                            message: '请选中一条数据进行上传图片！',
                            type: 'warning'
                        });
                        return false
                    }
                    this.sfllInitFiles = this.selectList[0].sfllpath ? this.selectList[0].sfllpath.split(',').filter(Boolean) : []
                    this.sfllVisible = true
                    break;
                case 16:
                    this.resetSrm()

                    break;
            }
        },
        // 回显sfllpath图片（多张逗号分隔）
        getSfllImgs(path) {
            if (!path) return []
            return path.split(',').filter(Boolean).map(item => this.imgUrl + '/' + item)
        },
        // 提交上传图片
        async subSfllpath() {
            let urlList = this.$refs.upDataImg.allUploadUrls
            if (!urlList || urlList.length < 1) {
                this.$message({
                    message: '请先上传图片！',
                    type: 'warning'
                });
                return false
            }
            if (urlList.length > 3) {
                this.$message({
                    message: '最多只能上传三张图片！',
                    type: 'warning'
                });
                return false
            }
            const res = await this.$http.updateSfllpath({
                sfllpath: urlList.join(','),
                spId: this.selectList[0].spId
            })
            if (res.status == 200) {
                this.$message({
                    type: 'success',
                    message: res.message,
                });
                this.sfllVisible = false
                this.getDataList()
            } else {
                this.$message({
                    message: res.message,
                    type: 'error'
                });
            }
        },
        async resetSrm() {
            if (this.selectList.length != 1) {
                this.$message({
                    message: '请选中一条数据！',
                    type: 'warning'
                });
                return false
            }
            const res = await this.$http.resetSrm({ ids: [this.selectList[0].spId] })
            if (res.status == 200) {
                this.$message({
                    type: 'success',
                    message: res.message,
                });
                this.getDataList()
            } else {
                this.$message({
                    message: res.message,
                    type: 'error'
                });
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        subztInfo() {
            this.$refs.ztInfo.validate(async (valid) => {
                if (valid) {
                    let res = await this.$http.closePlan({
                        carryName: this.ztInfo.carryName,
                        carryTime: this.ztInfo.carryTime,
                        carryNumberPlate: this.ztInfo.carryNumberPlate,
                        ids: this.selectList.map(item => item.spId)
                    })
                    if (res.status == 200) {
                        this.$message({
                            type: 'success',
                            message: res.message,

                        });
                        this.ztVisible = false
                        this.getDataList()
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        });
                    }
                }
            })

        },
        async closePlan() {

            if (this.selectList.length != 0) {
                this.ztVisible = true
                this.ztInfo = {}
            } else {
                this.$message({
                    message: '请至少选择一条数据！',
                    type: 'error'
                });
            }

        },
        async KdnStatusUrls() {
            console.log(this.selectList)
            if (this.selectList.length != 0) {
                let data = []
                //  data = { spId: this.selectList[0].spId }
                for (let i = 0; i < this.selectList.length; i++) {
                    data.push(String(this.selectList[i].spId))
                }
                console.log(data)
                let res = await this.$http.updateKdnStatusUrl(data)
                console.log(res)
                if (res.status == '200') {
                    this.$message({
                        type: 'success',
                        message: res.message,

                    });
                    this.getPageInfo()
                } else {
                    this.$message({
                        message: res.message,
                        type: 'warning'
                    });
                }


            } else {
                this.$message({
                    message: '请至少选择一条数据！',
                    type: 'error'
                });
            }

        },
        openWl() {
            if (this.selectList.length < 1) {
                this.$message({
                    message: '至少选中一条数据维护！',
                    type: 'error'
                });
                return false
            }
            for (let key in this.wlInfo) {
                this.wlInfo[key] = ''
            }
            this.wlVisible = true
        },
        showPrintPlan(type) {
            if (this.selectList.length < 1) {
                this.$message({
                    message: '请先选中要打印的数据',
                    type: 'error'
                });
                return false
            }
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                var info = this.selectList.map(item => item.woamId)
                var list = this.selectList.map(item => item.spId)
                // 1
                if (type == 9) {
                    this.$refs.printPlan.openDia(info, '/printData/printShipTag', 123456123, '', 'all', '', '')

                } else {
                    this.$refs.printPlan.openDia(info, '/printData/printTemplatePrint', sessionStorage.getItem('printJurId'), '', 'all', '', '', list)
                }
            } else {
                return
            }
        },
        //  确认
        async subEdit() {  //shipPlanUpdate
            let responseData = await this.$http.shipPlanUpdate(this.editOrder)
            if (responseData.status == 200) {
                this.$message({
                    type: 'success',
                    message: responseData.message,
                });
                this.editVisible = false
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }

            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: [dataInfo.crId]
                }
                let responseData = await this.$http.unitCreditDeleteUnitCredit(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });

                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => { });
        },

        // 提交审核
        submitDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }

            this.$confirm('确定要提交审核?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    businessKey: dataInfo.crId
                }
                let responseData = await this.$http.unitCreditSubmitAudit(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '操作成功'
                    });

                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => { });
        },

        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            })
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 200)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 200)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.formDataList = this.pageShowData.jurFormVoList
                this.getButtonList()
                this.getDataList(true)
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        // 获取数据列表
        async getDataList(flag = false) {
            let responseData = await this.$http.shipPlanQuery(this.getRequestData)
            if (flag) {
                this.$store.state.tableNum++
            }
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.pages = responseData.result.pages
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
                this.selectList = []
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        //获得状态
        getIsGsp(str, val) {
            try {
                if (str.indexOf('[') === -1) return val
                str && str.replace(/\\/g, '')
                let arr = JSON.parse(str)
                let len = arr.length
                let newStr = ''
                for (let i = 0; i < len; i++) {
                    if (arr[i].key == val) {
                        newStr = arr[i].value
                        break;
                    }
                }
                return newStr ? newStr : val
            } catch (ex) {
                return val
            }
        },

        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },
        //结束时间改成最后时间
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1
                this.getRequestData.end = time
            }
        },

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}
::v-deep .baseForm .el-form-item__content {
    margin-left: 0 !important;
}
::v-deep.baseForm .el-textarea__inner,
.baseForm .el-date-editor.el-input {
    width: 193px !important;
}
.el-drawer {
    outline: none;
}
</style>